import React, { useContext } from 'react';
import { Search16 as IconSearch16 } from '@cian/ui-kit/icons';
import { useDeviceType } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';

import { toggleSearch } from '../../../reducers/modules/config/config';
import { TDispatch } from '../../../types/redux';
import { ReactPortal } from '../../../components/ReactPortal';
import { Search as SearchModal } from '../Search';
import { selectSearchShown } from '../../../selectors/searchShown';
import { ApplicationContext } from '../../../utils';
import * as s from './SearchButtonContainer.css';

/**
 * Кнопка вызова модалки с формой поиска
 */
export const SearchButtonContainer = () => {
  const dispatch = useDispatch<TDispatch>();
  const isSearchShown = useSelector(selectSearchShown);
  const deviceType = useDeviceType();
  const isDesktop = () => deviceType === 'desktop';
  const context = useContext(ApplicationContext);

  const handleClick = () => {
    dispatch(toggleSearch(true));
  };

  return (
    <>
      {isDesktop() && (
        <div className={`${s['wrapper']}`} onClick={handleClick}>
          <IconSearch16 />
          <span className={`${s['text']}`}>Поиск по журналу</span>
        </div>
      )}

      <ReactPortal wrapperId={'search-modal'} parent={context.config.getStrict<string>('projectName')}>
        {isSearchShown && (
          <div className={s['search-modal-wrapper']}>
            <SearchModal />
          </div>
        )}
      </ReactPortal>
    </>
  );
};
